import script from "./website.vue?vue&type=script&lang=js"
export * from "./website.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/components/form/input-only/website.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5e7e394"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5e7e394', __exports__)) {
    console.log('reload')
    api.reload('a5e7e394', __exports__)
  }
  
}


export default __exports__